import { useQuery } from '@tanstack/react-query';
import salesAgentService from '@/lib/api/salesAgent';

export function useSalesAgent(organizationId: string | undefined | null) {
  return useQuery({
    queryKey: ['salesAgent', organizationId],
    queryFn: async () => {
      if (!organizationId) throw new Error('Organization ID required');
      const response = await salesAgentService.getSalesAgent(organizationId);
      if (!response.success || !response.data) {
        throw new Error(response.error || 'Failed to fetch sales agent');
      }
      return response.data;
    },
    enabled: !!organizationId,
    staleTime: 10 * 60 * 1000,
    gcTime: 15 * 60 * 1000,
  });
}
